<template>
  <div>

    <div class="ui huge menu">
      <a href="#" class="item" @click.prevent="triggerMenu">
        <i class="content icon"></i>
      </a>
      <a href="#" class="item" @click.prevent="dateMinus"><i class="icon arrow left"></i></a>
      <div class="calendar item">
        <div class="ui basic calendar" id="calendar1">
          <div class="ui icon input">
            <i class="calendar icon"></i>
            <input type="text" name="date" placeholder="Datum">
          </div>
        </div>
      </div>
      <a href="#" class="item" @click.prevent="datePlus"><i class="icon arrow right"></i></a>
      <div class="calendar item">
        <div class="ui basic calendar" id="calendar2">
          <div class="ui icon input">
            <i v-if="!filters.dateTo" class="calendar icon"></i>
            <i v-else class="close link icon" @click="clearDateTo()"></i>
            <input type="text" name="date" placeholder="Date filter to" autocomplete="off">
          </div>
        </div>
      </div>
      <div class="text input item">
        <div class="ui input left icon">
          <i class="barcode icon"></i>
          <input type="text" placeholder="Search Code" v-model="filters.code">
        </div>
      </div>
      <!--<div class="right menu"></div>-->
      <!--<div class="item">-->
        <!--Daily Income: <div class="ui blue basic large label">€{{ numeral(dailyReport.income).format('0,0.00') }}</div>-->
      <!--</div>-->
      <!--<div class="item">
        <div class="ui input left icon">
          <i class="user icon"></i>
          <input type="text" placeholder="Search By Name" v-model="filters.name">
        </div>
      </div>-->
    </div>
    <div class="ui container" style="padding-bottom: 50px">
      <h3 class="ui header">
        Reservations
      </h3>

      <div class="ui loader" :class="{ 'active': fetching }"></div>

      <!--<table class="ui table">-->
        <!--<thead>-->
          <!--<tr>-->
            <!--<th>-->
              <!--Name-->
            <!--</th>-->
            <!--<th>-->
              <!--Code-->
            <!--</th>-->
            <!--<th>-->
              <!--Boat-->
            <!--</th>-->
            <!--<th>-->
              <!--Time-->
            <!--</th>-->
            <!--<th>-->
              <!--Booked-->
            <!--</th>-->
            <!--<th>-->
              <!--Payment-->
            <!--</th>-->
            <!--<th>-->
              <!--Status-->
            <!--</th>-->
            <!--<th class="collapsing">-->
              <!--Actions-->
            <!--</th>-->
          <!--</tr>-->
        <!--</thead>-->
        <!--<tbody>-->
          <reservation-row v-for="reservation in reservations" :reservation="reservation" :boats="boats" :key="reservation._id" @triggerDetails="openReservationDetails" @printReceipt="printReceipt"></reservation-row>
          <div class="ui message" v-if="reservations.length === 0">
            There are no reservations for selected date or search criteria.
          </div>
        <!--</tbody>-->
      <!--</table>-->


    </div>

    <div class="pickup receipt" v-show="false">
      <p>Code: <strong>{{ receipt.code }}</strong></p>
      <p>Boat: <strong>{{ receipt.boat }}</strong></p>
    </div>

    <details-modal :reservationProp="editReservation" :boats="boats"></details-modal>

  </div>
</template>

<script type="text/ecmascript-6">
  import * as services from './../../services/'
  import ReservationRow from './reservations/ReservationRow'
  import DetailsModal from './reservations/DetailsModal'

  export default {
    data() {
      return {
        'reservations': [],
        'date': null,
        'settings': {},
        'filters': {
            'code': null,
            'name': null,
            'date': moment().format('YYYY-MM-DD'),
            'dateTo': undefined
        },
        'receipt': {
          'code': null,
          'boat': null
        },
        'editReservation': null,
        'fetching': false,
        'dailyReport': {
          'date': null,
          'income': 0,
        },
        'moment': moment,
        'numeral': numeral,
        boats: []
      }
    },
    watch: {
        filters: {
            deep: true,
            handler: function () {
              this.fetchReservations()
            }
        },
    },
    mounted() {
      this.fetchReservations()
      this.fetchBoats()

      services.settingService.find({
        $limit: 1,
        $sort: { _id: -1 }
      }).then(settings => {
        console.log(settings)
        if (settings.total > 0) this.settings = settings.data[0]
      })

      services.reservationService.on('created', reservation => this.fetchReservations())

      services.reservationService.on('patched', reservation => {
        let index = this.reservations.findIndex(arrayReservation => {
          return arrayReservation._id == reservation._id
        })

        if (index == -1) return;

        this.reservations.splice(index, 1, reservation)

        if (this.editReservation && reservation._id === this.editReservation._id) {
          this.editReservation = reservation
        }
      })

      const formatter = {
        date: (date, settings) => { return moment(date).format('dddd, LL') }
      }

      $('#calendar1').calendar({
        type: 'date',
        initialDate: new Date(),
        formatter: formatter,
        text: {
          months: ['Januar', 'Februar', 'März', 'April', 'May', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'],
          today: 'Heute',
          now: 'Jetzt'
        },
        onChange: (date, text) => {
          this.filters.date = moment(date).format('YYYY-MM-DD')
        }
      }).calendar('set date', new Date())

      $('#calendar2').calendar({
        type: 'date',
        initialDate: new Date(),
        formatter: formatter,
        text: {
          months: ['Januar', 'Februar', 'März', 'April', 'May', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'],
          today: 'Heute',
          now: 'Jetzt'
        },
        onChange: (date, text) => {
          if (!date) {
            this.filters.dateTo = undefined
            return
          }
          this.filters.dateTo = moment(date).format('YYYY-MM-DD')
        }
      })

      $('.huge.menu').visibility({
        type: 'fixed',
        offset: 0
      });
    },
    beforeDestroy() {
      $('.ui.modals').remove()
      services.reservationService.removeListener('created')
      services.reservationService.removeListener('updated')
      services.reservationService.removeListener('patched')
      services.reservationService.removeListener('removed')
    },
    methods: {
      clearDateTo() {
        $('#calendar2').calendar('set date', undefined)
      },
      fetchReservations() {
        this.fetching = true

        let queryPart = {}

        if (this.filters.code) {
          queryPart = { code: { $search: this.filters.code } }
        } else {
          if (this.filters.dateTo) {
            queryPart['firstBooking.date'] = {
              $gte: this.filters.date,
              $lte: this.filters.dateTo
            }
          } else {
            queryPart = {
              ...this.filters.date && { 'firstBooking.date': this.filters.date }
            }
          }
        }

        services.reservationService.find({query: {
          ...queryPart,
//          ...this.filters.name && { $or: [{ 'contact.firstName': {$search: this.filters.name }}, { 'contact.lastName': {$search: this.filters.name }}] },
          status: { $in: ['reserved', 'checkIn', 'inProgress', 'returned', 'paid', 'checkOut'] },
          $sort: { 'firstBooking.date': -1, 'firstBooking.hour': 1 }
        }}).then(reservations => {
          this.fetching = false
          this.reservations = reservations.data
          this.initDropdown()
        })
      },
      datePlus() {
        $('#calendar1').calendar('set date', moment(this.filters.date).add(1, 'd').format())
        this.initDropdown()
      },
      dateMinus() {
        $('#calendar1').calendar('set date', moment(this.filters.date).subtract(1, 'd').format())
        this.initDropdown()
      },
      initDropdown() {
        setTimeout(() => {
          $('.ui.dropdown').dropdown()
        }, 50)
      },
      triggerMenu() {
        $('.ui.sidebar').sidebar('toggle')
      },
      openReservationDetails(reservation) {
          console.log('open reservation')
          this.editReservation = reservation
          $('#reservationModal').modal({
            debug: true
          }).modal('show')
      },
      printReceipt(reservation) {
        this.receipt.code = reservation.code
        this.receipt.boat = reservation.boat.name
        setTimeout(() => {
          let w=window.open();
          w.document.write($('.pickup.receipt').html());
          w.print();
          w.close();
        })
      },
      fetchBoats() {
        services.boatService.find({query: {$sort: {'type': 1, 'name': 1}}}).then((boats) => {
          this.boats = boats.data
        })
      }
    },
    components: {
        ReservationRow, DetailsModal
    }
  }
</script>

<style scoped>
  .ui.calendar input {
    border: none;
    font-size: 1.3rem;
  }
  .calendar.item {
    padding: 4px 1px 0;
  }
  .text.input input {
    border: none;
  }
  .text.input.item {
    padding: 10px;
  }
  .huge.menu.placeholder {
    height: 65px;
  }
</style>



// WEBPACK FOOTER //
// Reservations.vue?fae160ee